module.exports = __webpack_public_path__ + "static/media/ibca-bangalore.ebfaf340.png";